import styled from "styled-components";

const FormLabel = styled.label`
  display: block;
  max-width: 380px;
  width: 100%;
  margin: 40px auto 0px 0px;
  text-align: left;
  padding-left: 10px;
  color: #333;
  font-size: 1.2rem;
  font-weight: bold;
  font-family: "Roboto", sans-serif;
`;

export default FormLabel;
